const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'DESPESA_TIPO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'DESPESA_TIPO_USUARIO_SELECT_LISTADO':
            return { ...state,
				listaUsuario: action.payload.data
			};

        case 'DESPESA_TIPO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
